import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDataDeletion = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 412,
	height: 140,
	viewBox: "0 0 412 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 66.7083,
			y2: -.45,
			transform: "matrix(-0.974391 -0.22486 -0.22486 0.974391 82 51)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 25.6125,
			y2: -.45,
			transform: "matrix(0.624695 -0.780869 -0.780869 -0.624695 95 47)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3236,
			y2: -.45,
			transform: "matrix(0.914918 0.40364 0.40364 -0.914918 123 24)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.99999 26C13.4183 26 17 29.5817 17 34C17 38.4183 13.4183 42 8.99999 42C4.58171 42 1 38.4183 1 34C1 29.5817 4.58171 26 8.99999 26Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M8.99999 31C10.6568 31 12 32.3431 12 34C12 35.6569 10.6568 37 8.99999 37C7.34313 37 6 35.6569 6 34C6 32.3431 7.34313 31 8.99999 31Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116 13C120.418 13 124 16.5817 124 21C124 25.4183 120.418 29 116 29C111.582 29 108 25.4183 108 21C108 16.5817 111.582 13 116 13Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116 18C117.657 18 119 19.3431 119 21C119 22.6569 117.657 24 116 24C114.343 24 113 22.6569 113 21C113 19.3431 114.343 18 116 18Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90 44.999C94.4183 44.999 98 48.5807 98 52.999C98 57.4173 94.4183 60.999 90 60.999C85.5817 60.999 82 57.4173 82 52.999C82 48.5807 85.5817 44.999 90 44.999Z",
			stroke: "#DBDEE6",
			strokeWidth: .91,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M90 49.999C91.6569 49.999 93 51.3422 93 52.999C93 54.6559 91.6569 55.999 90 55.999C88.3431 55.999 87 54.6559 87 52.999C87 51.3422 88.3431 49.999 90 49.999Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 74.3229,
			y2: -.45,
			transform: "matrix(-0.920735 -0.390189 -0.390189 0.920735 284.432 114)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 55.4437,
			y2: -.45,
			transform: "matrix(0.991998 0.126254 0.126254 -0.991998 340 48)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("line", {
			y1: -.45,
			x2: 64.0078,
			y2: -.45,
			transform: "matrix(0.484316 -0.874893 -0.874893 -0.484316 297 111)",
			stroke: "#DBDEE6",
			strokeWidth: .9
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 40C336.418 40 340 43.5817 340 48C340 52.4183 336.418 56 332 56C327.582 56 324 52.4183 324 48C324 43.5817 327.582 40 332 40Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M332 45C333.657 45 335 46.3431 335 48C335 49.6569 333.657 51 332 51C330.343 51 329 49.6569 329 48C329 46.3431 330.343 45 332 45Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 48C407.418 48 411 51.5817 411 56C411 60.4183 407.418 64 403 64C398.582 64 395 60.4183 395 56C395 51.5817 398.582 48 403 48Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M403 53C404.657 53 406 54.3431 406 56C406 57.6569 404.657 59 403 59C401.343 59 400 57.6569 400 56C400 54.3431 401.343 53 403 53Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M292 109C296.418 109 300 112.582 300 117C300 121.418 296.418 125 292 125C287.582 125 284 121.418 284 117C284 112.582 287.582 109 292 109Z",
			stroke: "#DBDEE6",
			strokeWidth: .9,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .9,
			d: "M292 114C293.657 114 295 115.343 295 117C295 118.657 293.657 120 292 120C290.343 120 289 118.657 289 117C289 115.343 290.343 114 292 114Z",
			fill: "#BFDAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.1123 80.4978C74.7469 82.9883 76.2793 85.5433 77.7734 88.1137L79.9807 91.979L82.1227 95.8835L79.6795 95.513L83.2057 91.8685C84.3816 90.657 85.5927 89.481 86.7799 88.278L88.2158 86.8288L89.215 88.5891C89.9339 89.8529 90.6159 91.142 91.3164 92.4185C92.0169 93.6949 92.6804 94.9966 93.3611 96.2758C94.0147 97.5789 94.6869 98.8694 95.3122 100.186C95.9559 101.491 96.5726 102.819 97.161 104.162L96.0956 104.783C95.2264 103.6 94.387 102.413 93.5645 101.204C92.7336 100.006 91.948 98.7717 91.1454 97.5597C90.3697 96.3239 89.577 95.1106 88.8099 93.8635C88.0527 92.615 87.2784 91.3891 86.5411 90.1379L88.9762 90.449C87.8003 91.6605 86.6357 92.8806 85.4372 94.075L81.8518 97.657L80.3251 99.1792L79.3988 97.2878L77.4453 93.2866L75.5486 89.2575C74.3096 86.5612 73.1075 83.8396 72.009 81.0634L73.1023 80.4992L73.1123 80.4978Z",
			fill: "#FF7B74"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M287.599 27C286.319 29.69 285.15 32.43 284.02 35.18L282.359 39.31L280.77 43.47L283.14 42.77L279.15 39.64C277.82 38.6 276.46 37.6 275.12 36.57L273.5 35.33L272.75 37.21C272.21 38.56 271.709 39.93 271.189 41.29C270.669 42.65 270.189 44.03 269.689 45.39C269.219 46.77 268.729 48.14 268.289 49.53C267.829 50.91 267.4 52.31 267 53.72L268.14 54.19C268.84 52.9 269.509 51.61 270.159 50.3C270.819 49 271.429 47.67 272.059 46.36C272.659 45.03 273.28 43.72 273.87 42.38C274.45 41.04 275.049 39.72 275.609 38.38L273.24 39.02C274.57 40.06 275.89 41.11 277.24 42.13L281.28 45.19L283 46.49L283.659 44.49L285.049 40.26L286.38 36.01C287.24 33.17 288.06 30.31 288.77 27.41L287.609 27H287.599Z",
			fill: "#FF7B74"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M175.64 58.9146L129.807 73.1733C125.588 74.4858 123.232 78.9699 124.544 83.1887L139.834 132.337C141.147 136.555 145.631 138.912 149.85 137.599L195.683 123.34C199.902 122.028 202.258 117.544 200.945 113.325L185.655 64.177C184.343 59.9581 179.859 57.6021 175.64 58.9146Z",
			fill: "#FF7B74"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 129.462,
			y1: 82.4786,
			x2: 181.12,
			y2: 66.4078,
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M164.899 78.3918L148.666 83.4417C146.821 84.0159 145.735 85.8011 146.241 87.4289C146.748 89.0568 148.654 89.9109 150.5 89.3367L166.733 84.2868C168.578 83.7125 169.664 81.9274 169.158 80.2996C168.651 78.6717 166.745 77.8176 164.899 78.3918Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M149.929 100.832C149.771 100.323 149.716 99.7882 149.767 99.258L152.742 68.5534C152.895 66.9769 153.963 65.639 155.467 65.1415L178.887 57.3941C181.082 56.668 183.434 57.9487 184.015 60.1867L199.062 118.154C199.598 120.22 198.417 122.344 196.378 122.978L164.129 133.011C162.02 133.667 159.778 132.489 159.121 130.38L149.929 100.832Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M252 70H188C183.582 70 180 73.5817 180 78V132C180 136.418 183.582 140 188 140H252C256.418 140 260 136.418 260 132V78C260 73.5817 256.418 70 252 70Z",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M252 121H229C227.343 121 226 122.343 226 124V132C226 133.657 227.343 135 229 135H252C253.657 135 255 133.657 255 132V124C255 122.343 253.657 121 252 121Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 239.55,
			y1: 126.45,
			x2: 230.45,
			y2: 126.45,
			stroke: "white",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 245.55,
			y1: 130.45,
			x2: 230.45,
			y2: 130.45,
			stroke: "white",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.5 85H211.5C209.567 85 208 86.3432 208 88C208 89.6569 209.567 91 211.5 91H228.5C230.433 91 232 89.6569 232 88C232 86.3432 230.433 85 228.5 85Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 184.45,
			y1: 79.55,
			x2: 255.55,
			y2: 79.55,
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M239 0H175C170.582 0 167 3.58172 167 8V62C167 66.4183 170.582 70 175 70H239C243.418 70 247 66.4183 247 62V8C247 3.58172 243.418 0 239 0Z",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M214.5 15H197.5C195.567 15 194 16.3432 194 18C194 19.6569 195.567 21 197.5 21H214.5C216.433 21 218 19.6569 218 18C218 16.3432 216.433 15 214.5 15Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 170.45,
			y1: 9.55,
			x2: 243.55,
			y2: 9.54999,
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M239 0H175C170.582 0 167 3.58172 167 8V62C167 66.4183 170.582 70 175 70H239C243.418 70 247 66.4183 247 62V8C247 3.58172 243.418 0 239 0Z",
			fill: "#E9EBF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M215.5 15H198.5C196.567 15 195 16.3432 195 18C195 19.6569 196.567 21 198.5 21H215.5C217.433 21 219 19.6569 219 18C219 16.3432 217.433 15 215.5 15Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 171.45,
			y1: 9.55,
			x2: 242.55,
			y2: 9.54999,
			stroke: "#002E5F",
			strokeWidth: .9,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M187.5 70C187.5 70 212.5 78.5 228 76C233.356 75.1361 240 70 240 70H187.5Z",
			fill: "#CED3DE"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M54.2999 7.64996C54.2999 9.66996 52.6699 11.3 50.6499 11.3C48.6299 11.3 47 9.66996 47 7.64996C47 5.62996 48.6299 4 50.6499 4C52.6699 4 54.2999 5.62996 54.2999 7.64996Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M380.3 96.65C380.3 98.67 378.67 100.3 376.65 100.3C374.63 100.3 373 98.67 373 96.65C373 94.63 374.63 93 376.65 93C378.67 93 380.3 94.63 380.3 96.65Z",
			fill: "#006ADC"
		})
	]
});
const ForwardRef = forwardRef(SvgDataDeletion);
export default ForwardRef;
